/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Gap_FramesInputs */



/**
* | output |
* | --- |
* | "Event Gap (Frames)" |
*
* @param {Event_Gap_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_gap_frames = /** @type {((inputs?: Event_Gap_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Gap_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart entre événements (images)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignislücke (Frames)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gap evento (frame)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разрыв между событиями (фреймы)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Brecha de eventos (fotogramas)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件间隙（帧）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントギャップ（フレーム）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना अंतराल (फ्रेम)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo de eventos (quadros)")
	return /** @type {LocalizedString} */ ("Event Gap (Frames)")
});